import { UserManagementActionType } from '@modules/users/store/userManagementActionType';
import {
  UserManagementState,
  UserManagementAction,
} from '@modules/users/store/types';
import { getUserRowRoleFromUserTypeAndState } from '@modules/users/utils';

export const userManagementReducer = (
  state: UserManagementState,
  action: UserManagementAction,
): UserManagementState => {
  switch (action.type) {
    case UserManagementActionType.SET_USERS_DATA: {
      return {
        ...state,
        users: action.payload.users,
      };
    }

    case UserManagementActionType.UPDATE_USER: {
      const { id, user: partialUser } = action.payload;

      return {
        ...state,
        users: state.users.map((user) => {
          if (user.id !== id) {
            return user;
          }
          const updatedUser = { ...user, ...partialUser };
          const updatedUserRole =
            partialUser.role ??
            getUserRowRoleFromUserTypeAndState(
              updatedUser.type,
              updatedUser.state,
            );
          return {
            ...updatedUser,
            role: updatedUserRole,
          };
        }),
      };
    }

    case UserManagementActionType.SET_VISUAL: {
      return {
        ...state,
        visual: {
          ...state.visual,
          ...action.payload,
        },
      };
    }

    case UserManagementActionType.SET_AUTO_APPROVAL_STATE: {
      return {
        ...state,
        isAutoApprovalDisabled: action.payload.isAutoApprovalDisabled,
      };
    }

    default:
      return state;
  }
};
